module.exports = __webpack_public_path__ + "media/alcohol_training/alcohol_training_green-204bd255.png";